export default new class UserTab {
    constructor() {
        this.sUserContentTabId = '_data-user-';

        this.sChangeTabSelectClass = '_change_tab_user_select';
        this.sChangeTabButtonClass = '_change_tab_user_button';

        this.sActiveTabDesktopClass = '_tab_desktop _change_tab_user_button inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm';
        this.sNotActiveTabDesktopClass = '_tab_desktop _change_tab_user_button text-indigo-600 hover:text-indigo-700 px-3 py-2 font-medium text-sm rounded-md underline';

        this.sTabDesktopClass = '_tab_desktop';

        this.sContentClass = '_tab_content';

        this.sTabWrapperClass = '_tab-user-wrapper';

        this.sActiveContentClass = 'active';

        this.sResultWrapperClass = '_result_wrapper';

        this.click();
        this.change();
    }

    click() {
        $(document).on('click', `.${this.sChangeTabButtonClass}`, (obEvent) => {
            event.preventDefault();

            let obButton = $(obEvent.target);
            let iTabId = obButton.attr('data-value');
            if (iTabId === undefined) {
                obButton = obButton.closest('a');
                iTabId = obButton.attr('data-value');
            }

            const obTabList = $(`.${this.sTabDesktopClass}`);
            const sContent = $(`#${this.sUserContentTabId}${iTabId}`).html();
            const obContentList = $(`.${this.sContentClass}`);

            obTabList.attr('class', this.sNotActiveTabDesktopClass);

            obButton.attr('class', this.sActiveTabDesktopClass);

            $(`.${this.sResultWrapperClass}`).html('');
            obContentList.removeClass(this.sActiveContentClass).html('');
            $(`[data-tab=${iTabId}]`).addClass(this.sActiveContentClass).html(sContent);
        });
    }

    change() {
        $(document).on('change', `.${this.sChangeTabSelectClass}`, (obEvent) => {
            const obSelect = $(obEvent.target);
            const iTabId = obSelect.val();
            const sContent = $(`#${this.sUserContentTabId}${iTabId}`).html();
            const obContentList = $(`.${this.sContentClass}`);

            obContentList.removeClass(this.sActiveContentClass).html('');
            $(`[data-tab=${iTabId}]`).addClass(this.sActiveContentClass).html(sContent);
        });
    }
}();
